export default __webpack_public_path__ + "3d0c461b81bfc159887beccf2a37f1b7.png";